<template>
  <v-row>
    <v-col cols="12" sm="10" offset-sm="1">
      <v-card>
        <v-card-title primary-title>
          <div class="text-h5">
            Följesedel / leveransreklamation          
          </div>
          <v-spacer />
          <v-icon v-if="$vuetify.breakpoint.mdAndDown" large color="primary" @click="$refs.deliveryInfoDialog.open()">
            info
          </v-icon>
        </v-card-title>
        <v-card-subtitle>
          Saknas hela leveransen vänligen kontakta <a href="https://kvallstidningarna.se/kontakt/">kundcenter</a>.
        </v-card-subtitle>
        <v-card-text>          
          <i v-if="Object.keys(deliveryDates).length < 1">Inga leveranser</i>
        </v-card-text>
      
        <v-list v-if="$vuetify.breakpoint.mdAndDown" two-line :expand="true">
          <v-list-group
            v-for="(value, k) in deliveryDates"
            :key="k"
            v-model="value.active"
            prepend-icon="mdi-truck"
            no-action
          >
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> 
                  {{ k | longPaperDate }} 
                  <v-icon v-if="hasMessage(value[0])" large color="primary" style="float:right; font-size:1.5em;" @click.native.stop="showMessage(value[0])">
                    info
                  </v-icon>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-for="p in value" :key="p.id" class="pl-3" @click="showDialog(p)">            
              <v-list-item-content>
                <v-list-item-title>
                  <v-row>
                    <v-col cols="4">
                      {{ p.title }}
                    </v-col>                      
                    <v-col cols="5">
                      <template v-if="p.type === 1">
                        {{ p.edition }}
                      </template>
                    </v-col>                     
                    <v-col cols="4">
                      Antal: {{ p.deliveredAmount }}
                    </v-col>    
                  </v-row>
                </v-list-item-title>              
                <v-list-item-subtitle>
                  {{ p.description }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="ml-0">                
                <v-chip v-if="Number.isInteger(p.receivedAmount)" text-color="white" :small="false" :color="p.deliveredAmount === p.receivedAmount ? 'green darken-3' : 'red darken-2'">
                  <span style="color:white;">{{ p.receivedAmount }}</span>
                </v-chip>

                <v-btn v-if="!Number.isInteger(p.receivedAmount)" icon ripple>
                  <v-icon color="grey">
                    more_horiz
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list>
        <v-expansion-panels v-else
                            v-model="panel"
                            multiple
                            class="pl-2 pr-2"
        >
          <v-expansion-panel v-for="(value, k) in deliveryDates" :key="k" expanded>
            <v-expansion-panel-header class="text-h6 text-uppercase">       
              <v-row dense>
                <v-col cols="2">
                  <span>
                    <v-icon class="pr-2">mdi-truck</v-icon>
                    {{ k | longPaperDate }}              
                  </span>
                  <v-icon v-if="hasMessage(value[0]) && $vuetify.breakpoint.isMobile" large color="primary" style="float:right; font-size:1.5em;" @click.native.stop="showMessage(value[0])">
                    info
                  </v-icon>
                </v-col>
                <v-col v-if="hasMessage(value[0]) && !$vuetify.breakpoint.isMobile" cols="9">
                  <v-alert 
                    dense
                    colored-border
                    border="top"
                    type="error"
                    class="mb-0"
                    icon="mdi-information"
                  >
                    <!-- eslint-disable vue/no-v-html -->
                    <div v-html="value[0].message" />
                    <!--eslint-enable-->
                  </v-alert>
                </v-col>
              </v-row>                           
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row v-if="$vuetify.breakpoint.mdAndUp"  
                     class="text-6 font-weight-light text-uppercase"
                     align="center"
              > 
                <v-col cols="2">
                  Titel
                </v-col>
                <v-col cols="2">
                  Utgåva
                </v-col>
                <v-col cols="3">
                  Beskrivning
                </v-col>                             
                <v-col cols="1" class="text-center">
                  Antal
                </v-col>                                    
                <v-col cols="1" class="text-center">
                  Mottagit
                </v-col>  
              </v-row>       
              
              <template v-if="$vuetify.breakpoint.mdAndDown">
                <v-list-item v-for="p in value" :key="p.id" class="pa-0" @click="showDialog(p)">
                  <v-list-item-content class="pa-0">
                    <v-row align="center"                                         
                           class="pa-0" 
                    >
                      <v-col cols="2">
                        {{ p.title }}
                      </v-col>                      
                      <v-col cols="2">
                        <template v-if="p.type === 1">
                          {{ p.edition }}
                        </template>
                      </v-col>   
                      <v-col cols="2">
                        {{ p.description }}
                      </v-col>                      
                      <v-col cols="2"
                             class="text-center"
                      >
                        {{ p.deliveredAmount }}
                      </v-col>
                      <v-spacer />                  
                      <v-col class="text-right"> 
                        <v-list-item-action class="ml-0">                
                          <v-chip v-if="Number.isInteger(p.receivedAmount)" text-color="white" :small="true" :color="p.deliveredAmount === p.receivedAmount ? 'green darken-3' : 'red darken-2'">
                            <span style="color:white;">{{ p.receivedAmount }}</span>
                          </v-chip>

                          <v-btn v-if="!Number.isInteger(p.receivedAmount)" x-small icon ripple>
                            <v-icon color="grey">
                              more_horiz
                            </v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-col>/        
                    </v-row>                  
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else>
                <v-list-item v-for="p in value" :key="p.id" class="pa-0">                  
                  <v-list-item-content class="pa-0">
                    <v-form v-model="p.valid">
                      <v-row align="center"                                         
                             class="pa-0"                           
                      >
                        <v-col cols="2"
                               :class="p.saved === true?'saved':''"
                        >
                          {{ p.title }}
                        </v-col>                      
                        <v-col cols="2"
                               :class="[p.saved === true?'saved':'', p.type === 0 ?'empty':'']"
                        >
                          <template v-if="p.type === 1">
                            {{ p.edition }}
                          </template>
                        </v-col>   
                        <v-col cols="3"                      
                               :class="[p.saved === true?'saved':'', p.description.length === 0 ?'empty':'']"
                        >
                          {{ p.description }}
                        </v-col>                      
                        <v-col cols="1"
                               class="text-center"
                               :class="p.saved === true?'saved':''"
                        >
                          {{ p.deliveredAmount }}
                        </v-col>
                        <v-col cols="2">
                          <v-text-field v-model.number="p.receivedAmount"
                                        type="number"                        
                                        hide-details="auto"
                                        class="input"
                                        outlined                            
                                        dense                                                                                                                        
                                        :rules="[rules.validrange(p)]"                                                  
                                        @change="clearSaved(p)"                   
                          >
                            <template v-slot:append dark>
                              <v-tooltip v-if="equal(p)" 
                                         bottom                                         
                                         color="warning"                                         
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    color="warning"                                                                        
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-alert
                                  </v-icon>
                                </template>
                                <span class="white--text">Du ska bara rapportera avvikelser.</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-spacer /> 
                        <v-col v-show="p.saved===true" cols="1">
                        <!-- <v-chip v-if="Number.isInteger(p.receivedAmount)" text-color="white" :small="true" :color="p.deliveredAmount === p.receivedAmount ? 'green darken-3' : 'red darken-2'">
                          <span style="color:white;">{{ p.receivedAmount }}</span>
                        </v-chip> -->
                        </v-col>
                        <v-col cols="1" class="pl-0">
                          <v-btn small dense
                                 block                               
                                 color="success"           
                                 :disabled="p.valid === false"                     
                                 @click="save(p)"                           
                          >                        
                            Spara
                          </v-btn>         
                        </v-col>              
                      </v-row>                                    
                    </v-form>     
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-col>
    <DeliveryMessageDialog ref="deliveryMessageDialog" :show="messageDialog" :paper="paper" @close="$refs.deliveryMessageDialog.close()" />
    <DeliveryDialog :show="dialog" :paper="paper" @close="closeDialog" @saved="deliverySaved" />
    <DeliveryInfoDialog ref="deliveryInfoDialog" @close="$refs.deliveryInfoDialog.close()" />
  </v-row>
</template>

<script>
import DeliveryDialog from '@/components/web/dialogs/DeliveryDialog'
import DeliveryInfoDialog from '@/components/web/dialogs/DeliveryInfoDialog'
import DeliveryMessageDialog from '@/components/web/dialogs/DeliveryMessageDialog'
import { mapState, mapMutations } from 'vuex'
import { APP_DELIVERY_DATES } from '@/store/appStates'
import { SET_DELIVERY, UPDATE_DELIVERY } from '@/store/appMutations'
import api from '@/backend/api'
import log from '@/logger'
import { groupBy, forEach} from 'lodash'

export default {
  name: 'Delivery',
  components: { DeliveryDialog, DeliveryInfoDialog, DeliveryMessageDialog },
  data() {
    return {
      dialog: false,
      messageDialog: false,
      paper: {},
      panel: [],
      rules:{
        validrange(item){          
          if(Math.sign(item.receivedAmount) === -1){
            return 'Kan inte vara negativt.'
          }
          else if(item.receivedAmount >='999') {
            return 'Orimligt värde.'
          }
          else {
            return true
          }
          // if(item.receivedAmount === item.deliveredAmount){
          //   return 'Du ska bara rapportera avvikelser.'
          // }        
        },             
      }
    }
  },
  computed: {
    ...mapState({
      deliveryDates: state => state[APP_DELIVERY_DATES],      
    })  ,
   
    
  },
  created() {
    this.loadData()
  },  
  mounted(){        
  },
  methods: {
    ...mapMutations({
      setDelivery: SET_DELIVERY,
      updateDelivery: UPDATE_DELIVERY
    }),
    equal(item){
      return (item.receivedAmount === item.deliveredAmount && (item.changed !== undefined))
    },
    showHint(item){
      if(item.receivedAmount === item.deliveredAmount){
        return 'Du ska bara rapportera avvikelser.'
      }
      else{
        return null
      }
    },
    save(paper) {
      if(paper.valid){
      this.loading = true

      var delivery = {
        received: paper.receivedAmount,
        delivered: paper.deliveredAmount,
        titleId: paper.titleId,
        editionId: paper.editionId,
        deliveryDate: paper.deliveryDate,
        type: paper.type
      }

      log.debug('Save Delivery:', delivery)

      api
        .saveDelivery(delivery)
        .then(resp => {
          this.loading = false
          var paper = resp.data
          log.debug('Success:', paper)          
          paper.saved = true
          paper.valid = true
          paper.changed = true
          this.updateDelivery(paper)
        })
        .catch(error => {
          this.loading = false
          log.debug('Errors:', error)
          paper.saved = false
        })
      }else{
        console.log('Paper not valid', paper)
      }
    },
    loadData() {
      const self= this
      api.getDelivery().then(resp => {
        log.debug('Delivery:', resp.data)       
        resp.data.forEach( paper=>{
          paper.saved = paper.receivedAmount !== null
        })
        this.setDelivery(resp.data)
        let dates = groupBy(resp.data, p => p.deliveryDate)
        let i = 0
        forEach(dates,function(){
          console.log(i)
          self.panel.push(i)
          i++
        })
        
      })
    },
    clearSaved(paper){
      paper.saved = false
      paper.changed = true
    },
    showMessage(paper){
      this.paper = Object.assign({}, paper)
      this.messageDialog = true      
      this.$refs.deliveryMessageDialog.open()
    },
    showDialog(paper) {
      this.paper = Object.assign({}, paper)
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    deliverySaved(paper) {
      log.debug('update:', paper)
      paper.saved = true
      this.updateDelivery(paper)
      this.dialog = false
    },
    hasMessage(paper){
      return paper.message !== undefined && paper.message !== null
    }
  }
}
</script>

<style scoped>
.input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.input >>> input::-webkit-outer-spin-button,
.input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.saved{
  background-color:green;
  color:white;   
}
.empty{
  padding-top:2em;
  
}
</style>